"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateUnderWritingReview = exports.underwritingReviewSchema = void 0;
/* eslint-disable camelcase */
var schema_validator_1 = require("@hobt/schema-validator");
var underwriting_review_check_1 = require("./underwriting-review-check");
var underwriting_review_discloser_1 = require("./underwriting-review-discloser");
exports.underwritingReviewSchema = {
    type: 'object',
    required: ['check', 'cmhcLoanAccountNumber', 'discloser'],
    properties: {
        check: {
            type: 'integer',
            enum: Object.values(underwriting_review_check_1.UnderwritingReviewCheck),
            errorMessage: 'Should equate to a valid Check Enum value',
        },
        cmhcLoanAccountNumber: {
            type: 'integer',
            maximum: 99999999,
            minimum: 1000000,
            errorMessage: 'Should be numeric between 1000000 to 99999999',
        },
        discloser: {
            type: 'integer',
            enum: Object.values(underwriting_review_discloser_1.UnderwritingReviewDiscloser),
            errorMessage: 'Should equate to a valid Discloser Enum value',
        },
        checkUpdatedToFailTimestamp: {
            type: ['string', 'null'],
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'Should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        checkUpdatedToPassTimestamp: {
            type: ['string', 'null'],
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'Should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
    },
};
exports.validateUnderWritingReview = function (data, addAuditFields) {
    if (addAuditFields === void 0) { addAuditFields = false; }
    var underwritingReviewValidator = new schema_validator_1.SchemaValidator(exports.underwritingReviewSchema, true, true, true, true);
    if (addAuditFields) {
        underwritingReviewValidator.extendSchema(schema_validator_1.auditFieldsSchema);
    }
    return underwritingReviewValidator.validate(data);
};
